import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dimmer, Header, Icon, Loader, Segment, Table } from "semantic-ui-react";
import agent from "../../api/agent";
import { toast } from "react-toastify";
import { useStore } from "../../stores/store";
import SemesterReportDto from "../../models/Reports/semesterReportDto";
import * as XLSX from "xlsx";

export default function SemesterReport() {
  const { t } = useTranslation("common");
  const { lookupsStore, commonStore } = useStore();
  const [records, setRecords] = useState<SemesterReportDto[]>([]);
  const [inProgress, setInProgress] = useState<boolean>(true);

  useEffect(() => {
    agent.Reports.semesterReport()
      .then((result) => setRecords(result))
      .catch((error) => handleError(error))
      .finally(() => setInProgress(false));
  }, []);

  const exportExcel = () => {
    var table_elt = document.getElementById("tblReport");
    const workSheet = XLSX.utils.table_to_sheet(table_elt);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Data");
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workBook, "semester_report.xlsx");
  };

  const handleError = (error: any) => toast.error(t("Common.GeneralErrorMessage"));

  const loader = (
    <Segment className="injaz-loader-tbl">
      <Dimmer active inverted>
        <Loader size="large">{t("Common.Loading")} ...</Loader>
      </Dimmer>
    </Segment>
  );

  const table = (
    <div id="semester-tbl" className="reports-tbl">
      <Table id="tblReport">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            {records &&
              records.length > 0 &&
              records[0].courses &&
              records[0].courses.length > 0 &&
              records[0].courses.map((record, index) => (
                <Table.HeaderCell className="alt-color" colSpan="2" key={index}>
                  {record.programName}
                </Table.HeaderCell>
              ))}
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>#</Table.HeaderCell>
            <Table.HeaderCell>{t("UserManagement.Teachers.SchoolName")}</Table.HeaderCell>
            <Table.HeaderCell>{t("Reports.Gender")}</Table.HeaderCell>
            <Table.HeaderCell>{t("Reports.Area")}</Table.HeaderCell>
            <Table.HeaderCell>{t("Reports.Governate")}</Table.HeaderCell>
            <Table.HeaderCell>{t("Common.Directorate")}</Table.HeaderCell>
            <Table.HeaderCell>{t("CourseManagement.AcademicYear")}</Table.HeaderCell>
            <Table.HeaderCell>{t("ProgramManagement.Semester")}</Table.HeaderCell>
            {records &&
              records.length > 0 &&
              records[0].courses &&
              records[0].courses.length > 0 &&
              records[0].courses.map((record, index) => (
                <>
                  <Table.HeaderCell className="alt-color-sub" key={index}>
                    {t("Reports.Enrolled")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="alt-color-sub" key={index}>
                    {t("Reports.Graduated")}
                  </Table.HeaderCell>
                </>
              ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {records &&
            records.length > 0 &&
            records.map((record, index) => (
              <Table.Row key={index}>
                <Table.Cell>{record.institutionId}</Table.Cell>
                <Table.Cell>{record.schoolName}</Table.Cell>
                <Table.Cell>
                  {lookupsStore.getInstitutionGenderTypeValue(record.schoolGender, commonStore.lang)}
                </Table.Cell>
                <Table.Cell>{lookupsStore.getAreaValue(record.areaId, commonStore.lang)}</Table.Cell>
                <Table.Cell>{record.governateName}</Table.Cell>
                <Table.Cell>{record.directorateName}</Table.Cell>
                <Table.Cell>{record.academicYear}</Table.Cell>
                <Table.Cell>
                  {lookupsStore.getSemsterValue(record.semesterId, commonStore.lang)}
                </Table.Cell>
                {record.courses &&
                  record.courses.length > 0 &&
                  record.courses.map((course, index) => (
                    <>
                      <Table.Cell className="alt-color-cell" key={index}>
                        {course.enrolledCount}
                      </Table.Cell>
                      <Table.Cell className="alt-color-cell" key={index}>
                        {course.graduatedCount}
                      </Table.Cell>
                    </>
                  ))}
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    </div>
  );

  const content = (
    <>
      <div className="ui menu injaz-forms-btns">
        <div className="item">
          <Button basic color="blue" onClick={exportExcel}>
            <Icon name="download" />
          </Button>
        </div>
      </div>
      {table}
    </>
  );

  return (
    <>
      <nav className="injaz-breadcrumbs">
        <a href="/" className="injaz-breadcrumbs__item">
          <Icon name="home" />
        </a>
        <a href="/reports" className="injaz-breadcrumbs__item">
          Reports
        </a>
        <a href="#checkout" className="injaz-breadcrumbs__item is-active">
          <span>{t("Reports.SemesterReport")}</span>
        </a>
      </nav>
      <Header as="h1">{t("Reports.SemesterReport")}</Header>
      {inProgress && loader}
      {!inProgress && content}
    </>
  );
}
